import { useState } from 'react';

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@base/Dialog';
import { ButtonSecondary, ButtonDefault } from '@base/Button/Button';

export const DialogRemove = (props) => {
    const [loading, setLoading] = useState(false);

    const actions = () => {
        return (
            <>
                <ButtonSecondary
                    disabled={loading}
                    onClick={() => { setLoading(true); props.handleConfirm(props.id, setLoading) }}
                    startIcon={loading ? <CircularProgress size={16} /> : <CheckOutlinedIcon />}
                    style={{ margin: 4 }}
                    name="Remover"
                />
                <ButtonDefault
                    onClick={props.close}
                    startIcon={<ClearOutlinedIcon />}
                    style={{ margin: 4 }}
                    name="Cancelar"
                />
            </>
        )
    }

    return (
        <>
            <Dialog
                openDialog={props.open}
                title={props.title}
                closeDialog={props.close}
                actions={actions()}
                fullWidth={true}
                maxWidth={props.maxWidth ?? "md"}
            >
                {props.text}
            </Dialog>
        </>
    )
}

export default DialogRemove;
